import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { selectAdvertisingPageCategory } from '../../../../../utils/advertising/selectAdvertisingPageCategory';
import SiteLayout from '../../../../layouts/SiteLayout/SiteLayout';
import SiteSection from '../../../../layouts/SiteLayout/SiteSection/SiteSection';
import HeadingSection from '../../../../siteBaseSections/HeadingSection/HeadingSection';
import Advertising from '../../../../shared/Advertising/Advertising';
import { InformaMetaTagPageType } from '../../../../../constants';
import { Helmet } from 'react-helmet';

export function BasePageView(props) {
  const {
    title: defaultPageTitle,
    informaPageId,
    siteHeader: { meta: { title: defaultTitle } = {} } = {},
    siteContent: {
      data: {
        sections = [],
        details: { pageTitle, titleSize, showPageHeader } = {},
      } = {},
      meta: { title: contentTitle } = {},
    } = {},
    pageCategory,
  } = props;
  const middleIndex = Math.floor(sections.length / 2);

  return (
    <SiteLayout
      helmet={{
        title: contentTitle || `${defaultPageTitle} | ${defaultTitle}`,
      }}
    >
      <Helmet>
        <meta name="informa-page-id" content={informaPageId} />
        <meta
          name="informa-page-type"
          content={InformaMetaTagPageType.BasePage}
        />
      </Helmet>
      {showPageHeader && (
        <HeadingSection
          title={pageTitle || defaultPageTitle}
          titleSize={titleSize}
        />
      )}

      {sections.map((section, index) => (
        <Fragment key={section.id}>
          <SiteSection section={section} index={index} />
          {index === middleIndex && (
            <Advertising
              advSlots={[{ slotId: '728_2' }]}
              advSize="728_90"
              pageCategory={pageCategory}
            />
          )}
        </Fragment>
      ))}
      {props.children}
    </SiteLayout>
  );
}

BasePageView.propTypes = {
  title: PropTypes.string,
  informaPageId: PropTypes.string,
  siteHeader: PropTypes.shape({
    meta: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  siteContent: PropTypes.shape({
    data: PropTypes.shape({
      sections: PropTypes.arrayOf(PropTypes.object),
    }),
    meta: PropTypes.shape({
      title: PropTypes.string,
    }),
  }),
  children: PropTypes.node,
};

function mapStateToProps(state) {
  return {
    siteHeader: state.siteHeader,
    siteContent: state.siteContent,
    pageCategory: selectAdvertisingPageCategory(state),
  };
}

export default connect(mapStateToProps)(BasePageView);
